import {
  GET_REJECT_SLOT_OPTIONS,
  GET_REJECT_SLOT_OPTIONS_SUCCESS,
  GET_REJECT_SLOT_OPTIONS_ERROR,
  GET_REJECT_SLOT_OPTIONS_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetRejectSlotOptions = (state = initialState, action) => {
  switch (action.type) {
    case GET_REJECT_SLOT_OPTIONS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_REJECT_SLOT_OPTIONS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_REJECT_SLOT_OPTIONS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_REJECT_SLOT_OPTIONS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetRejectSlotOptions;
